import React, { ComponentType } from 'react'

import ReactHtmlParser from 'react-html-parser'
import { Header } from '../Header/Header'
import { SubHeading } from '../SubHeading/SubHeading'
import { Button } from '../Button'

export type HighlightTextProps = {
  subTitle?: string
  title: string
  text?: string
  link?: string
  cta?: string
  marketoFormId?: string
  handleAcessReport?: (item: any) => void
  handleReportClick?: () => void
  target?: string
  renderLink?: ComponentType<HighlightTextRenderLinkProps>
}

export type HighlightTextRenderLinkProps = Partial<HighlightTextProps>

const renderLinkDefault = ({
  link,
  cta = '',
  marketoFormId,
  handleReportClick = () => {},
  handleAcessReport,
  target
}: HighlightTextRenderLinkProps) => {
  if (marketoFormId) {
    return (
      <Button
        handleClick={handleAcessReport}
        title={cta}
        className="frw-button frw-button--6-2"
      />
    )
  }
  if (link && cta) {
    return (
      <a
        aria-label={cta}
        onClick={handleReportClick}
        className="frw-button frw-button--6-2"
        href={link}
        target={target || '_self'}
      >
        {cta}
      </a>
    )
  }
  return null
}

export const HighlightText = ({
  subTitle = 'n/a',
  title,
  text = '<p>n/a</p>',
  renderLink: Link = renderLinkDefault,
  ...props
}: HighlightTextProps) => (
  <article className="frw-va">
    {subTitle === 'n/a' ? null : <SubHeading>{subTitle}</SubHeading>}
    <Header level={2} className="frw-heading--2">
      {title}
    </Header>
    {text === '<p>n/a</p>' ? null : (
      <p className="frw-markdown">{ReactHtmlParser(text)}</p>
    )}
    <Link {...props} />
  </article>
)
export default HighlightText
